import { render, staticRenderFns } from "./FarmerDetail.vue?vue&type=template&id=5d19ee0e&scoped=true"
import script from "./FarmerDetail.vue?vue&type=script&lang=js"
export * from "./FarmerDetail.vue?vue&type=script&lang=js"
import style0 from "./FarmerDetail.vue?vue&type=style&index=0&id=5d19ee0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19ee0e",
  null
  
)

export default component.exports